/// <amd-module name="Reporting/BoardsCommon/ReportError" />
import * as React from "react";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

export interface ReportErrorProps {
    errorMessage: string;
}
/** Common abstraction for Errors on Report Pages. */
export class ReportError extends React.Component<ReportErrorProps> {
    public render(): JSX.Element {
        return <MessageCard severity={MessageCardSeverity.Error}>{this.props.errorMessage}</MessageCard>;
    }
}
